/*
 * One-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * MultiplicationArray.js -
*/

import { StyleSheet, useWindowDimensions, View } from 'react-native';
import MultiplicationArrayElement from './MultiplicationArrayElement';

const HINT_SCREEN_INSET = 0.9;
const HINT_VERTICAL_SPACE = 0.8;
const HINT_PADDING = 0.9;
const THICKER_MARGIN = 10;

interface MultiplicationArrayProps {
  numCols: number,
  numRows: number
}

const MultiplicationArray = ({numCols, numRows}: MultiplicationArrayProps) => {

  const rows = [];
  const cols = [];

  const windowDimensions = useWindowDimensions();

  // Calculate the size of the array element by finding the smallest
  // ratio between screen width and number of columns or screen height and number of rows.
  const useableHeight = Math.floor(windowDimensions.height * HINT_SCREEN_INSET * HINT_VERTICAL_SPACE * HINT_PADDING);
  const elementHeight = Math.floor( useableHeight / numRows);
  const usableWidth = Math.floor(windowDimensions.width * HINT_SCREEN_INSET * HINT_PADDING) - THICKER_MARGIN;
  const elementWidth = Math.floor( usableWidth / numCols);
  const elementSize = Math.min(elementHeight, elementWidth);

  for (let i = 0; i < numCols; i++) {
    const color = i > 4 ? 'yellow' : 'red';
    const margin = i === 5 ? THICKER_MARGIN : 0;

    cols.push(
      <MultiplicationArrayElement key={`element${i}`} width={elementSize} height={elementSize} color={color} margin={margin} />
    );
  }

  for (let i = 0; i < numRows; i++) {
    rows.push(
      <View style={styles.arrayRow} key={'colNum'+i}>
        {cols}
      </View>
    );
  }

  return (
    <View style={styles.array}>
      {rows}
    </View>
  );
};

export default MultiplicationArray;

const styles = StyleSheet.create({
  array: {
    flexDirection: 'column',
    marginBottom: 20,
    margin: 0,
    justifyContent: 'center',
    alignContent: 'center',
  },

  arrayRow: {
    flexDirection: 'row'
  }

});
